"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSocket = void 0;
var react_1 = require("react");
var socket_io_client_1 = require("socket.io-client");
var useSocket = function (_a) {
    var activeRole = _a.activeRole, _b = _a.initializeSocket, initializeSocket = _b === void 0 ? true : _b, namespace = _a.namespace, token = _a.token, userId = _a.userId;
    var _c = (0, react_1.useState)(null), socket = _c[0], setSocket = _c[1];
    (0, react_1.useEffect)(function () {
        if (initializeSocket) {
            var initializeSocket_1 = function () {
                if (userId && activeRole) {
                    try {
                        var socket_1 = (0, socket_io_client_1.io)("http://localhost:3003/".concat(namespace), {
                            auth: {
                                token: token,
                                userId: userId,
                                activeRole: activeRole,
                            },
                            reconnectionDelay: 5000,
                            reconnectionAttempts: 5,
                        });
                        setSocket(socket_1);
                    }
                    catch (err) {
                        console.log('Error: ', err);
                    }
                }
            };
            initializeSocket_1();
        }
    }, [activeRole, initializeSocket, namespace, token, userId]);
    return {
        socket: socket,
    };
};
exports.useSocket = useSocket;
